// EMP Marine TCO Calculator – Shopify-safe (no Shadow DOM, re-init on section load)
(function () {
  function initEmpTcoCalculator() {
    const mount = document.getElementById('emp-tco-calculator');
    if (!mount) return;

    // Prevent double-initialising on Shopify section reloads
    if (mount.dataset.empTcoInit === '1') return;
    mount.dataset.empTcoInit = '1';

    const root = mount;

    /* =============== CSS =============== */
    const css = `
      .tco-emp {
        max-width: 900px;
        margin: 0 auto;
        --tco-bg:#DEE4EB;
        --tco-card:#ffffff;
        --tco-text:#0f172a;
        --tco-muted:#475569;
        --tco-border:#d6dbe2;
        --tco-accent:#0E2A47;
        --tco-focus:rgba(0,120,255,.65);
        --tco-gap:16px;
        --tco-radius:14px;
        font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Helvetica,Arial;
        color:var(--tco-text);
      }
      .tco-emp {
        background:var(--tco-bg);
        border:1px solid var(--tco-border);
        border-radius:16px;
        padding:clamp(16px,3vw,28px);
      }

      .tco-layout { display:grid; gap:var(--tco-gap); }
      @media (min-width:900px) { .tco-layout { grid-template-columns:repeat(2,1fr); } }

      .tco-card {
        background:var(--tco-card);
        border:1px solid var(--tco-border);
        border-radius:var(--tco-radius);
        padding:14px;
      }
      .tco-label {
        font-size:12px;
        color:var(--tco-muted);
        margin:0 0 6px;
        text-transform:uppercase;
        letter-spacing:.5px;
      }
      .tco-fields { display:grid; gap:var(--tco-gap); grid-template-columns:1fr 1fr; }
      @media (max-width:640px) { .tco-fields { grid-template-columns:1fr; } }
      @media (min-width:900px) { .tco-card.emp .tco-fields { grid-template-columns:repeat(2,1fr); } }

      .tco-field { display:grid; gap:6px; }
      .tco-input {
        width:100%;
        min-height:44px;
        padding:10px 12px;
        border:1px solid var(--tco-border);
        border-radius:10px;
        background:#fff;
      }
      .tco-input:focus {
        outline:3px solid var(--tco-focus);
        outline-offset:2px;
      }

      .tco-actions {
        display:flex;
        gap:12px;
        margin:18px 0;
        flex-wrap:wrap;
        justify-content:center;
      }
      .tco-btn {
        appearance:none;
        border:1px solid var(--tco-accent);
        background:var(--tco-accent);
        color:#fff;
        padding:10px 14px;
        border-radius:10px;
        font-weight:600;
        cursor:pointer;
      }
      .tco-btn.secondary {
        background:#fff;
        color:var(--tco-accent);
      }

      .tco-results {
        border:2px solid #0E2A47;
        border-radius:var(--tco-radius);
        padding:14px;
        background:#f7f9fc;
        margin-top:16px;
      }
      .tco-results h3.heading {
        margin:0 0 10px;
        font-size:14px;
        text-transform:uppercase;
        letter-spacing:.5px;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:12px;
        flex-wrap:wrap;
      }
      .toggle {
        display:inline-flex;
        align-items:center;
        gap:8px;
        font-size:12px;
        color:var(--tco-muted);
      }

      .tco-kpis { display:grid; gap:var(--tco-gap); grid-template-columns:1fr 1fr; }
      @media (min-width:720px) { .tco-kpis { grid-template-columns:repeat(4,1fr); } }
      .kpi {
        background:#fff;
        border:1px solid var(--tco-border);
        border-radius:12px;
        padding:12px;
      }
      .kpi .k {
        font-size:12px;
        color:var(--tco-muted);
        margin:0 0 6px;
      }
      .kpi .v {
        font-size:20px;
        font-weight:700;
        font-variant-numeric:tabular-nums lining-nums;
        min-height:1.6em;
      }

      .tco-results-body { display:grid; gap:var(--tco-gap); }
      @media (min-width:900px) { .tco-results-body { grid-template-columns:1.1fr .9fr; } }

      table.tco-table {
        width:100%;
        border-collapse:collapse;
        font-size:14px;
      }
      table.tco-table th,
      table.tco-table td {
        padding:10px 8px;
        border-bottom:1px dashed var(--tco-border);
        text-align:left;
      }
      table.tco-table th {
        color:var(--tco-muted);
        font-weight:600;
      }

      .tco-chart {
        background:#fff;
        border:1px solid var(--tco-border);
        border-radius:12px;
        padding:10px;
      }
      .tco-chart svg { width:100%; height:220px; display:block; }
      .tco-chart .axis { stroke:#cbd5e1; stroke-width:1; }
      .tco-chart .line-current { fill:none; stroke:#0E2A47; stroke-width:2.5; }
      .tco-chart .line-emp { fill:none; stroke:#6B93B5; stroke-width:2.5; }
      .tco-chart text { font-size:12px; fill:var(--tco-text); }

      .tco-disclaimer {
        font-size:12px;
        color:var(--tco-muted);
        margin-top:20px;
        line-height:1.5;
      }
    `;

    /* =============== HTML =============== */
    const html = `
      <div class="tco-emp">
        <div class="tco-layout">
          <div class="tco-card">
            <div class="tco-label">Current system</div>
            <div class="tco-fields">
              <div class="tco-field">
                <label for="curType">Type</label>
                <select id="curType" class="tco-input">
                  <option value="petrol" selected>Petrol outboard</option>
                  <option value="brushed">Brushed DC</option>
                </select>
              </div>
              <div class="tco-field">
                <label for="curFuelPrice" id="lblCurFuelPrice">Fuel price (A$/L)</label>
                <input id="curFuelPrice" class="tco-input" type="number" min="0" step="0.01" value="2.10">
              </div>
              <div class="tco-field">
                <label for="curFuelUsage" id="lblCurFuelUsage">Fuel usage (L/h)</label>
                <input id="curFuelUsage" class="tco-input" type="number" min="0" step="0.01" value="1.875">
              </div>
              <div class="tco-field">
                <label for="curMaint">Maintenance per year (A$)</label>
                <input id="curMaint" class="tco-input" type="number" min="0" step="10" value="460">
              </div>
              <div class="tco-field">
                <label for="curUpfront">Upfront purchase cost (A$)</label>
                <input id="curUpfront" class="tco-input" type="number" min="0" step="50" value="4000">
              </div>
              <div class="tco-field">
                <label for="curDriveEff">Drivetrain efficiency (0–1)</label>
                <input id="curDriveEff" class="tco-input" type="number" min="0.1" max="1" step="0.01" value="0.65">
              </div>
            </div>
          </div>

          <div class="tco-card emp">
            <div class="tco-label">EMP BLDC marine system</div>
            <div class="tco-fields">
              <div class="tco-field">
                <label for="empVoltage">System voltage (V)</label>
                <input id="empVoltage" class="tco-input" type="number" min="12" step="1" value="48">
              </div>
              <div class="tco-field">
                <label for="empElecDraw">Electric draw (kW)</label>
                <input id="empElecDraw" class="tco-input" type="number" min="0" step="0.1" value="5.6">
              </div>
              <div class="tco-field">
                <label for="empElecPrice">Electricity price (A$/kWh)</label>
                <input id="empElecPrice" class="tco-input" type="number" min="0" step="0.01" value="0.30">
              </div>
              <div class="tco-field">
                <label for="empMaint">Maintenance per year (A$)</label>
                <input id="empMaint" class="tco-input" type="number" min="0" step="10" value="50">
              </div>
              <div class="tco-field">
                <label for="empUpfront">Upfront purchase cost (A$ motor only)</label>
                <input id="empUpfront" class="tco-input" type="number" min="0" step="50" value="1249">
              </div>
              <div class="tco-field">
                <label for="batteryTotal">Battery replacement cost (A$ per pack, every 5 years)</label>
                <input id="batteryTotal" class="tco-input" type="number" min="0" step="50" value="1200">
              </div>
            </div>
          </div>
        </div>

        <div class="tco-layout" style="margin-top:16px;">
          <div class="tco-card">
            <div class="tco-label">Estimated usage</div>
            <div class="tco-fields">
              <div class="tco-field">
                <label for="hoursPerDay">Operating hours per day</label>
                <input id="hoursPerDay" class="tco-input" type="number" min="0" step="0.1" value="1">
              </div>
              <div class="tco-field">
                <label for="daysPerYear">Days per year</label>
                <input id="daysPerYear" class="tco-input" type="number" min="1" step="1" value="100">
              </div>
            </div>
          </div>
          <div class="tco-card">
            <div class="tco-label">Financial considerations</div>
            <div class="tco-fields">
              <div class="tco-field">
                <label for="analysisYears">Analysis horizon (years)</label>
                <input id="analysisYears" class="tco-input" type="number" min="1" step="1" value="10">
              </div>
              <div class="tco-field">
                <label for="drPct">Discount rate (%)</label>
                <input id="drPct" class="tco-input" type="number" min="0" step="0.1" value="0.0">
              </div>
            </div>
          </div>
        </div>

        <div class="tco-actions">
          <button class="tco-btn" id="btnCalc" type="button">Calculate</button>
          <button class="tco-btn secondary" id="btnReset" type="button">Reset</button>
        </div>

        <div class="tco-results">
          <h3 class="heading">
            Results
            <span class="toggle">
              <input type="checkbox" id="toggleDiscountChart"> Apply discount to chart
            </span>
          </h3>

          <div class="tco-kpis">
            <div class="kpi"><div class="k">Payback period</div><div class="v" id="kpiPayback">–</div></div>
            <div class="kpi"><div class="k">Total saving</div><div class="v" id="kpiSaving">–</div></div>
            <div class="kpi"><div class="k">Baseline annual spend</div><div class="v" id="kpiBaseAnnual">–</div></div>
            <div class="kpi"><div class="k">EMP annual spend</div><div class="v" id="kpiEmpAnnual">–</div></div>
          </div>

          <div class="tco-results-body" style="margin-top:12px;">
            <div>
              <table class="tco-table">
                <thead>
                  <tr><th>Line item</th><th>Current system</th><th>EMP BLDC</th></tr>
                </thead>
                <tbody>
                  <tr><td>Upfront cost</td><td id="tblCurUpfront">–</td><td id="tblEmpUpfront">–</td></tr>
                  <tr><td>Annual energy/fuel cost</td><td id="tblCurEnergy">–</td><td id="tblEmpEnergy">–</td></tr>
                  <tr><td>Annual maintenance</td><td id="tblCurMaint">–</td><td id="tblEmpMaint">–</td></tr>
                  <tr><td><span id="tblYears">10</span>-year TCO</td><td id="tblCurTCO">–</td><td id="tblEmpTCO">–</td></tr>
                </tbody>
              </table>
            </div>
            <div id="tcoChart" class="tco-chart" aria-label="Cumulative TCO line chart"></div>
          </div>
        </div>

        <div class="tco-disclaimer">
          <strong>Assumptions and disclaimers</strong><br>
          Default values compare an 8 hp petrol outboard with an EMP160-style 48 V brushless DC system over 10 years, operated for 100 hours per year at cruise.<br>
          The petrol scenario assumes fuel usage of 1.875 L/h at A$2.10/L, annual maintenance of A$460, and an upfront motor cost of A$4,000.<br>
          The EMP scenario assumes electric draw of 5.6 kW at A$0.30/kWh, annual maintenance of A$50, an upfront motor cost of A$1,249 plus an initial A$1,200 battery pack, and additional A$1,200 battery replacements every 5 years. Replacement packs are included only when the analysis horizon is long enough (for example, one replacement over 10 years).<br>
          The calculator focuses on operating and maintenance-related costs and excludes installation, charging infrastructure, incentives, and taxes. Update inputs to reflect your own usage, tariffs, and pricing for more accurate results.<br>
          For typical recreational use, the default estimate of 1 hour per day over 100 days per year aligns with common small-vessel patterns. Commercial or survey-class vessels, or operators running higher annual hours (for example 200–300+ hours per year), should adjust usage inputs to reflect heavier duty cycles. These scenarios will generally increase the relative savings achieved with an EMP system. Commercial or survey-class vessels may require AMSA approval under novel vessel rules. Contact EMP for guidance.
        </div>
      </div>
    `;

    // Mount HTML + CSS
    const tpl = document.createElement('template');
    tpl.innerHTML = `<style>${css}</style>${html}`;
    root.innerHTML = '';
    root.appendChild(tpl.content.cloneNode(true));

    /* =============== Utilities =============== */
    const AUD = (v, d = 0) =>
      new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        maximumFractionDigits: d
      }).format(v);

    const NUM = (v, d = 2) =>
      new Intl.NumberFormat('en-AU', { maximumFractionDigits: d }).format(v);

    const g = (id) => root.querySelector('#' + id);

    const val = (id) => {
      const el = g(id);
      return el ? parseFloat(el.value || '0') : 0;
    };

    const setText = (id, t) => {
      const el = g(id);
      if (el) el.textContent = t;
    };

    const hoursPerYear = () =>
      Math.max(0, val('hoursPerDay')) * Math.max(0, val('daysPerYear'));

    const npv = (annual, years, r) => {
      if (!r) return annual * years;
      let s = 0;
      for (let t = 1; t <= years; t++) {
        s += annual / Math.pow(1 + r, t);
      }
      return s;
    };

    /* =============== Core calc =============== */
    function compute() {
      const yrs = Math.max(1, Math.floor(val('analysisYears') || 10));
      const r = Math.max(0, val('drPct') || 0) / 100;
      const hpy = hoursPerYear();

      // Current system
      const curEnergy = val('curFuelUsage') * hpy * val('curFuelPrice');
      const curMaint = val('curMaint');
      const curAnnual = curEnergy + curMaint;

      // EMP system
      const empEnergy = val('empElecDraw') * hpy * val('empElecPrice');

      const packCost = val('batteryTotal');
      const extraReplacements = Math.max(0, Math.ceil(yrs / 5) - 1); // every 5 years beyond initial pack
      const batteryAnnual = extraReplacements > 0 ? (packCost * extraReplacements) / yrs : 0;

      const empMaintBase = val('empMaint');
      const empMaint = empMaintBase + batteryAnnual;
      const empAnnual = empEnergy + empMaint;

      const curUp = val('curUpfront');
      const empUpMotorOnly = val('empUpfront');
      const empUp = empUpMotorOnly + packCost; // motor + initial battery pack

      const curTCO = curUp + npv(curAnnual, yrs, r);
      const empTCO = empUp + npv(empAnnual, yrs, r);

      const annualSavings = curAnnual - empAnnual;
      const upfrontDelta = empUp - curUp;
      const paybackYears =
        upfrontDelta > 0 && annualSavings > 0 ? upfrontDelta / annualSavings : null;

      return {
        yrs,
        r,
        cur: { up: curUp, energy: curEnergy, maint: curMaint, annual: curAnnual, tco: curTCO },
        emp: { up: empUp, energy: empEnergy, maint: empMaint, annual: empAnnual, tco: empTCO },
        saving: curTCO - empTCO,
        payback: paybackYears
      };
    }

    /* =============== Chart =============== */
    function renderChart(state, discounted) {
      const el = g('tcoChart');
      if (!el) return;

      const w = el.clientWidth || 600;
      const h = 220;
      const padL = 40, padB = 28, padR = 10, padT = 10;
      const years = state.yrs;

      const cur = [state.cur.up];
      const emp = [state.emp.up];

      for (let y = 1; y <= years; y++) {
        const disc = discounted ? 1 / Math.pow(1 + state.r, y) : 1;
        cur.push(cur[cur.length - 1] + state.cur.annual * disc);
        emp.push(emp[emp.length - 1] + state.emp.annual * disc);
      }

      const maxVal = Math.max(cur[cur.length - 1], emp[emp.length - 1]) * 1.1 || 1;
      const x = (i) => padL + ((w - padL - padR) * (i / years));
      const y = (v) => h - padB - (v / maxVal) * (h - padT - padB);
      const path = (arr) =>
        arr.map((v, i) => (i === 0 ? `M${x(i)},${y(v)}` : `L${x(i)},${y(v)}`)).join(' ');

      let ticks = '';
      for (let i = 0; i <= years; i++) {
        ticks += `<text x="${x(i)}" y="${h - padB + 14}" font-size="10" text-anchor="middle">${i}</text>`;
      }

      const svg =
        `<svg viewBox="0 0 ${w} ${h}" preserveAspectRatio="xMidYMid meet" role="img" aria-label="Cumulative TCO over ${years} years">` +
        `<line class="axis" x1="${padL}" y1="${h - padB}" x2="${w - padR}" y2="${h - padB}" />` +
        `<line class="axis" x1="${padL}" y1="${padT}" x2="${padL}" y2="${h - padB}" />` +
        `<text x="${w / 2}" y="${h - 2}" text-anchor="middle">Years</text>` +
        `<text x="0" y="${h / 2}" transform="rotate(-90, 0, ${h / 2})" text-anchor="middle">Cumulative Cost (AUD)</text>` +
        ticks +
        `<path class="line-current" d="${path(cur)}" />` +
        `<path class="line-emp" d="${path(emp)}" />` +
        `<text x="${x(years)}" y="${y(cur[cur.length - 1]) - 6}" text-anchor="end">${AUD(cur[cur.length - 1])} Current</text>` +
        `<text x="${x(years)}" y="${y(emp[emp.length - 1]) + 14}" text-anchor="end">${AUD(emp[emp.length - 1])} EMP</text>` +
        `</svg>`;

      el.innerHTML = svg;
    }

    /* =============== Render & Update =============== */
    function update() {
      const typeEl = g('curType');
      const lblPrice = g('lblCurFuelPrice');
      const lblUsage = g('lblCurFuelUsage');

      const type = typeEl ? typeEl.value : 'petrol';
      if (type === 'brushed') {
        if (lblPrice) lblPrice.textContent = 'Electricity price (A$/kWh)';
        if (lblUsage) lblUsage.textContent = 'Electric draw (kW)';
      } else {
        if (lblPrice) lblPrice.textContent = 'Fuel price (A$/L)';
        if (lblUsage) lblUsage.textContent = 'Fuel usage (L/h)';
      }

      const r = compute();

      setText('kpiPayback', r.payback == null || !isFinite(r.payback) ? 'N/A' : `${NUM(r.payback, 1)} yr`);
      setText('kpiSaving', AUD(r.saving));
      setText('kpiBaseAnnual', AUD(r.cur.annual));
      setText('kpiEmpAnnual', AUD(r.emp.annual));

      setText('tblCurUpfront', AUD(r.cur.up));
      setText('tblEmpUpfront', AUD(r.emp.up));
      setText('tblCurEnergy', AUD(r.cur.energy));
      setText('tblEmpEnergy', AUD(r.emp.energy));
      setText('tblCurMaint', AUD(r.cur.maint));
      setText('tblEmpMaint', AUD(r.emp.maint));
      setText('tblYears', r.yrs);
      setText('tblCurTCO', AUD(r.cur.tco));
      setText('tblEmpTCO', AUD(r.emp.tco));

      const discounted = !!(g('toggleDiscountChart') && g('toggleDiscountChart').checked);
      renderChart(r, discounted);
    }

    function bind() {
      const calcBtn = g('btnCalc');
      const resetBtn = g('btnReset');

      if (calcBtn) calcBtn.addEventListener('click', update);

      if (resetBtn) {
        resetBtn.addEventListener('click', function () {
          root.querySelectorAll('.tco-input').forEach((el) => {
            el.value = el.defaultValue;
          });
          update();
        });
      }

      root.querySelectorAll('.tco-input').forEach((el) => el.addEventListener('change', update));

      const typeSel = g('curType');
      if (typeSel) typeSel.addEventListener('change', update);

      const discToggle = g('toggleDiscountChart');
      if (discToggle) discToggle.addEventListener('change', update);
    }

    bind();
    update();
  }

  // Run on normal page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEmpTcoCalculator);
  } else {
    initEmpTcoCalculator();
  }

  // Run when Shopify Theme Editor reloads sections
  document.addEventListener('shopify:section:load', function () {
    // Allow re-init after section reload (it gets re-rendered)
    const mount = document.getElementById('emp-tco-calculator');
    if (mount) mount.dataset.empTcoInit = '0';
    initEmpTcoCalculator();
  });
})();
